import dayjs from 'dayjs';

export const isSnowFallSeasonActive = (): boolean => {
  const now = dayjs();
  const month = now.month();
  const day = now.date();

  // Enabled from December 18 to January 10
  const isDecemberPeriod = month === 11 && day >= 18; // December 18-31
  const isJanuaryPeriod = month === 0 && day <= 5; // January 1-5

  return isDecemberPeriod || isJanuaryPeriod;
};
